import { CLASS_OVERVIEW_DATA_RETRIEVED } from './overview-actions';

const defaultState = [];

/**
 * Overview Reducer
 *
 * Consumes CLASS_OVERVIEW_DATA_RETRIEVED action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - current list of items to display in overview table
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case CLASS_OVERVIEW_DATA_RETRIEVED:
        return action.payload.data;
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/overview/overview-reducer.js